var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-left"),React.createElement("path",{"d":"M19.023 274.454v0l233.643 234.294c1.352 1.281 2.906 2.367 4.606 3.203l0.11 0.049v-28.128l-227.791-227.791 227.791-227.953v-28.128c-1.792 0.955-3.339 2.034-4.741 3.274l0.026-0.022-233.643 234.294-19.023 18.536z","key":1})]);
}

ArrowLeft.defaultProps = {"version":"1.1","width":"258","height":"512","viewBox":"0 0 258 512"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
